// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_RECENT_POSTS = "Najnov\u0161ie ot\u00e1zky z poradne";
export const FORUM_RELATED_DISCUSSIONS = "S\u00favisiace diskusie";
export const FORUM_SIMILAR_DISCUSSIONS = "Podobn\u00e9 diskusie";
export const RELATED_DISCUSSIONS_IN_FORUM = "S\u00favisiace diskusie";
export const YOUTUBE_MK_TITLE = "YouTube Modr\u00fd kon\u00edk";
